export default [
  {
    id: '1000',
    name: 'Aysha Julka',
    image: require('assets/images/avatar/A1.jpg'),
    message: 'commented on your profile picture.',
  },
  {
    id: '1001',
    name: 'Ayra Rovishi',
    image: require('assets/images/avatar/A2.jpg'),
    message: 'added to their stories.',
  },
  {
    id: '1002',
    name: 'Sapna Awasthi',
    image: require('assets/images/avatar/A3.jpg'),
    message: 'commented on your profile picture.',
  },
  {
    id: '1003',
    name: 'Sami Rudri',
    image: require('assets/images/avatar/A4.jpg'),
    message: 'tagged you in a picture.',
  },
  {
    id: '1004',
    name: 'Brian Lara',
    image: require('assets/images/avatar/A5.jpg'),
    message: 'marked himself safe during earth quake.',
  },
  {
    id: '1005',
    name: 'Rickey Ponting',
    image: require('assets/images/avatar/A6.jpg'),
    message: 'commented on your profile picture.',
  },
  {
    id: '1007',
    name: 'Smriti Mandhana',
    image: require('assets/images/avatar/A8.jpg'),
    message: 'changed her profile picture.',
  },
  {
    id: '1008',
    name: 'Aysha Julka',
    image: require('assets/images/avatar/A9.jpg'),
    message: 'changed her profile picture.',
  },
];
